import { VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { Field } from 'formik';
import { useSelector } from 'react-redux';

import { dropDownFormStyle } from 'components/forms/new/formStyles';

import appConfig from '@/config.json';

const LanguageField = ({ values, setFieldValue, FormFieldWithTooltip }) => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <FormFieldWithTooltip
            label="Language"
            tooltipLabel="Choose the language for date and time formatting (e.g., month names, day names)."
            fieldKey="language">
            <Field>
                {({ field }) => (
                    <VStack width="100%" alignItems="normal">
                        <Select
                            {...field}
                            tabSelectsValue
                            openMenuOnFocus
                            options={appConfig.datetime.language}
                            value={appConfig.datetime.language.find(
                                (o) => o.id === values?.timeZone?.language,
                            )}
                            getOptionLabel={(o) => o.displayName}
                            getOptionValue={(o) => o.id}
                            chakraStyles={dropDownFormStyle(darkMode)}
                            onChange={(e) => {
                                setFieldValue('timeZone', {
                                    ...values?.timeZone,
                                    language: e.id,
                                });
                            }}
                            selectedOptionColor="brand"
                            size="md"
                        />
                    </VStack>
                )}
            </Field>
        </FormFieldWithTooltip>
    );
};

export default LanguageField;
